var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"shopping-cart"}},[_c('CartToast'),_vm._v(" "),_c('div',{staticClass:"cart-container",class:{active: _vm.getShowCart}},[_c('Cart'),_vm._v(" "),_c('Checkout')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }